import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import { AuditEventSchema, DBAuditEventSchema } from './schemas';

export const AuditEventCodecConfig: TransformerConfig<
  typeof AuditEventSchema,
  typeof DBAuditEventSchema
> = {
  name: 'AuditEvent',
  clientSchema: AuditEventSchema,
  dbSchema: DBAuditEventSchema,
  transformers: [
    createTimestampTransformer<typeof AuditEventSchema, typeof DBAuditEventSchema>('createdAt'),
  ],
};

export const encodeAuditEventToDb = createEncodeToDbFn(AuditEventCodecConfig);
export const decodeAuditEventFromDb = createDecodeFromDbFn(AuditEventCodecConfig);
